import script from "./msgDetails.vue?vue&type=script&setup=true&name=MsgDetails&lang=js"
export * from "./msgDetails.vue?vue&type=script&setup=true&name=MsgDetails&lang=js"

import "./msgDetails.vue?vue&type=style&index=0&id=7afc135a&scoped=true&lang=css"

import exportComponent from "D:\\Jawsro\\company\\虎鲸\\v3\\hujing_pro_h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7afc135a"]])

export default __exports__